const Header = (props) => {
    return (
        <span style={{fontSize: 18 , lineHeight: "28px"  , fontWeight : 700, color: '#344054' }}>
            {props.children}
        </span>
    )

}
export default Header